import { MissionToStaffReport } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function getMissionToStaffReport(missionToStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.missionToStaffs.getMissionToStaffReport.url, { id: missionToStaffId })
    )
    .get<MissionToStaffReport>()
}
